import ReactHtmlParser from 'react-html-parser';
import { useTranslation } from 'react-i18next';

function AboutUsSection() {
  const { t } = useTranslation();
  return (
    <div className="outer-container">
      <div className="container">
        <div className="row">
          <div className="col-lg-offset-2 col-lg-8 col-md-offset-2 col-md-8 col-sm-offset-1 col-sm-10">
            <div className="message-container">
              <h1>{t('aboutUs.mission.aboutUs')}</h1>
              {ReactHtmlParser(t('aboutUs.mission.aboutUsText'))}
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .message-container {
          padding: 85px 0;
          font-size: 17px;
        }

        h1,
        h2 {
          font-size: 24px;
          margin: 0 0 18px 0;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
}

export default AboutUsSection;
